var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchool06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.933594,
    y: 0.865234,
    width: 350,
    height: 233,
    fill: "#D38D8D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.969 75.6523C194.969 73.4432 196.76 71.6523 198.969 71.6523H305.252C307.461 71.6523 309.252 73.4432 309.252 75.6523V154.004H194.969V75.6523Z",
    fill: "#112D33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.012 80.6934C200.012 78.4842 201.803 76.6934 204.012 76.6934H300.211C302.42 76.6934 304.211 78.4842 304.211 80.6934V152.322H200.012V80.6934Z",
    fill: "#357280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M280.414 146.111V140.17H282.531C283.914 140.17 284.591 140.999 284.591 142.098C284.591 143.194 283.91 144.027 282.531 144.027H281.317V146.111H280.414ZM281.317 143.255H282.441C283.315 143.26 283.68 142.767 283.68 142.098C283.68 141.425 283.315 140.945 282.441 140.941H281.317V143.255Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M285.765 146.169C285.444 146.165 285.178 145.906 285.182 145.586C285.178 145.266 285.444 145.003 285.765 145.003C286.08 145.003 286.343 145.266 286.347 145.586C286.343 145.906 286.08 146.165 285.765 146.169Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M287.48 146.111V140.17H289.597C290.98 140.17 291.657 140.999 291.657 142.098C291.657 143.194 290.975 144.027 289.597 144.027H288.382V146.111H287.48ZM288.382 143.255H289.507C290.381 143.26 290.746 142.767 290.746 142.098C290.746 141.425 290.381 140.945 289.507 140.941H288.382V143.255Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M293.413 140.17V146.111H292.535V140.17H293.413Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M296.4 146.202C295.087 146.202 294.278 145.295 294.283 143.912C294.278 142.542 295.099 141.598 296.342 141.598C297.356 141.598 298.32 142.226 298.32 143.838V144.15H295.152C295.177 144.999 295.678 145.479 296.408 145.479C296.904 145.479 297.229 145.266 297.376 144.995H298.263C298.066 145.717 297.38 146.202 296.4 146.202ZM295.157 143.493H297.458C297.458 142.816 297.019 142.316 296.351 142.32C295.649 142.316 295.193 142.866 295.157 143.493Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 193.289,
    y: 152.322,
    width: 117.645,
    height: 10.0838,
    rx: 4,
    fill: "#112D33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M193.289 155.684C193.289 153.827 194.794 152.322 196.65 152.322H307.572C309.429 152.322 310.934 153.827 310.934 155.684V155.684H193.289V155.684Z",
    fill: "#3E98A9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M304.211 152.322V80.6934C304.211 78.4842 302.42 76.6934 300.211 76.6934H205.389L295.961 152.322H304.211Z",
    fill: "#1D4953",
    fillOpacity: 0.59
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool06);
export default __webpack_public_path__ + "static/media/school_06.0dc0ee4fbcf3cb3cbadccae53b96063b.svg";
export { ForwardRef as ReactComponent };